/**
 * Wizard Progress Component
 *
 * Displays a progress bar showing completion percentage and step count.
 */

import React from 'react';
import { useWizard } from './Wizard';

export interface WizardProgressProps {
  className?: string;
  showPercentage?: boolean;
  showStepCount?: boolean;
}

export const WizardProgress: React.FC<WizardProgressProps> = ({
  className = '',
  showPercentage = true,
  showStepCount = true,
}) => {
  const { currentStep, totalSteps } = useWizard();

  const progressPercentage = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className={`wizard-progress ${className}`}>
      {/* Step Count & Percentage */}
      {(showStepCount || showPercentage) && (
        <div className="flex items-center justify-between mb-2 text-sm">
          {showStepCount && (
            <span className="text-gray-600 font-medium">
              Step {currentStep + 1} of {totalSteps}
            </span>
          )}
          {showPercentage && (
            <span className="text-gray-500">
              {Math.round(progressPercentage)}% Complete
            </span>
          )}
        </div>
      )}

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className="bg-primary-600 h-full transition-all duration-300 ease-out"
          style={{ width: `${progressPercentage}%` }}
          role="progressbar"
          aria-valuenow={progressPercentage}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
};
